export const fetcher = <T,>(
	url: RequestInfo,
	options?: RequestInit
): Promise<T> => {
	return fetch(url, options).then((res) => {
		switch (res.status) {
			case 200:
				return res.json()
			default:
				return res.json().then((error) => Promise.reject(error))
		}
	})
}
